export default __webpack_public_path__ + "static/1-e23b3434244d1157d74c120532b6f206.jpg";